/**
 * Live stream API base URL (Firebase Hosting rewrites → Cloud Functions).
 * Override at build time with REACT_APP_LIVE_STREAM_API_BASE.
 */
export const LIVE_STREAM_API_BASE =
  (typeof process !== 'undefined' && process.env.REACT_APP_LIVE_STREAM_API_BASE) ||
  'https://shock-iq-victorize.web.app/api/live';

export const LIVE_STREAM_HOSTING_ORIGIN = LIVE_STREAM_API_BASE.replace(/\/api\/live\/?$/, '');
